export const showKeyList = {
  showKey: ["parkName", "examineNew", "comment"],
  editKey: []
};
export const xxx = "xxx";
